import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import {deepCopyObject, showAxiosError, trimObject} from "../../util/Helpers";
import { Form, input } from "antd";
import Select from "react-select"
import Alert from "react-s-alert";
import {validateComponent, validateField} from "../../common/validation";
import moment from "moment";
import {Label, UncontrolledTooltip} from "reactstrap";
import './DocumentList.css';
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import UploaderDocument from "../../components/Uploader/UploaderDocument";
import 'react-datetime/css/react-datetime.css';

const {TextArea} = input;

class DocumentNoteModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            emailAvailabilityError: {},
            loading: false,
            isLoading: false,
            fieldsDisabled: false,
            mode: this.props.mode,
            selectedUsers:null,
            selectedGroups:null,
            documentInfo: {
                selectedUsers:null,
                selectedGroups:[],
                evrakNo: null,
                evrakKonu: "",
                evrakAciklama: "",
                evrakIlgiliYer: "",
                evrakTipi: null,
                belgeTuru: "",
                eimzaliMi: true,
                sureliMi: true,
                sureBitisTarihi: null,
                sevkGroupId: null ,
                sevkUserId: null,
                evrakFile: "",
                evrakPath: "",
                id: null,
                ad: "",
                soyad: "",
            },
            notes: {
                not: "",
                path: "",
                file: null,
                evrakSevkId: (this.props.selectedDocument.id),
            },

        };

        this.noteDocument = this.noteDocument.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.onChangeDocument = this.onChangeDocument.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.onChangeDateString = this.onChangeDateString.bind(this);
    }

    componentDidMount() {
        if (this.state.mode === 'review') {
            this.setState({fieldsDisabled: true});
        }
        if (this.props.selectedDocument) {
            let selectedDocument = deepCopyObject(this.props.selectedDocument);


            (selectedDocument.belgeTuru === "" || selectedDocument.belgeTuru === null) ? selectedDocument.belgeTuru = '' : selectedDocument.belgeTuru;
            selectedDocument.sureBitisTarihi = (selectedDocument.sureBitisTarihi !== null && selectedDocument.sureBitisTarihi !== "") ? moment.utc(selectedDocument.sureBitisTarihi, "YYYY-MM-DD") : null;

            this.setState({
                documentInfo: selectedDocument,
                documentInfo1: selectedDocument,

            });
            if (selectedDocument.isTransferred === true) {
                this.setState({fieldsDisabled: true});
            }
            // this.getUserInfo();
            // this.saveDocument()

        }
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }
    onChangeSelect(name, value) {
        let documentInfo = this.state.documentInfo;
        if (value === null) {
            documentInfo[name] = null
        } else {
            documentInfo[name] = value.value;
        }
        this.setState({documentInfo});
    }
    onSelectInfoChange(name,value){
        let documentInfo=this.state.documentInfo;
        console.log("value",value);
        console.log("documentInfo",documentInfo);
        if(value===null) {
            documentInfo[name]=[];
        }
        else {
            documentInfo[name]=[];
            documentInfo[name]=value.slice();
        }
        this.setState({documentInfo });
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    onChangeDocument(name, value) {

        if (value instanceof moment) {
            value = moment.utc(value.format('DD.MM.YYYY').toString() + " 00:00", "DD.MM.YYYY HH:mm");
        }
        let notes = this.state.notes;
        notes[name] = value;
        this.setState({notes});
    }

    onChangeDateString(name, value) {
        if (value === "") {
            value = null;
        }
        if (value !== null) {
            let splitted = value.split(".");
            value = splitted[2] + "-" + splitted[1] + "-" + splitted[0];
        }
        let documentInfo = this.state.documentInfo;
        documentInfo[name] = value;
        this.setState({documentInfo});
    }

    onChangeDocumentLowerCase(name, value) {
        let notes = this.state.notes;
        notes[name] = value.toString().toLocaleLowerCase();
        this.setState({notes});
    }

    onSelectChange(name, value) {
        let documentInfo = this.state.documentInfo;
        if (value === null) {
            documentInfo[name] = null
        } else {
            documentInfo[name] = value.value;
        }
        this.setState({documentInfo});
    }

    noteDocument() {
        let self = this;
        let params;
        let data;
        let message;
        self.setState({isLoading: true});
        let document = deepCopyObject(this.state.notes);
        document = trimObject(document);
        data = document;

            message = 'Not Başarıyla Kaydedildi.'
            params = {
                url: API_BASE_URL + "/evrakSevkNot/",
                data: data,
                method: 'post'
            }

        request(params).then(() => {
            Alert.success(
                message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            self.setState({isLoading: false});
            this.cancelProcess();
            self.props.handleSearch(self.props.searchQuery, true);
        }).catch(function (error) {
            self.setState({isLoading: false});
            // showAxiosError(error);  // burası veri çekerken hata alınca alert veriyor...
        });
    }
    // noteName = () => {
    //     let self = this;
    //     let id = this.props.selectedDocument.id
    //     let params = {
    //         url: API_BASE_URL + "/evrakSevkNot/" + id ,
    //         method: "get",
    //     };
    //
    //     request(params)
    //         .then(response => {
    //             let noteName = response.data;
    //             self.setState({
    //                 noteName
    //             });
    //         })
    //         .catch(error => {
    //             showAxiosError(error);
    //         });
    // };

    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }

    render() {
        let sureBitisTarihi = this.props.selectedDocument.sureBitisTarihi ? {value: moment.utc(this.props.selectedDocument.sureBitisTarihi, "DD.MM.YYYY")} : {};
        console.log("notes", this.state.documentInfo)
        console.log("selected", this.props.selectedDocument)
        return (
            <div className="memberForm--main-container">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="memberForm-container">
                    <Form>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Evrak Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Oda İl: </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('odaIl')}>
                                    <input className="form-control uppercase"
                                           disabled
                                           type="text"
                                           name="odaIl"
                                           id="odaIl"
                                           value="Şanlıurfa"
                                        // value={this.state.documentInfo.odaIl || ""}
                                    />
                                    {this.validateMessage('odaIl') !== "" &&
                                    <UncontrolledTooltip placement="right" target="odaIl" delay={0}>
                                        {this.validateMessage("odaIl")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            {/*{(this.state.documentInfo.id !== null) &&*/}
                            <div className='row'>
                                <label className="col-sm-3">Evrak No: </label>
                                <div className={"col-sm-8 form-group" + this.validateClass('evrakNo')}>
                                    <input className="form-control"
                                           disabled
                                           type="text"
                                           name="evrakNo"
                                           id="evrakNo"
                                           defaultValue={this.props.selectedDocument.evrakNo}
                                    />
                                    {this.validateMessage('evrakNo') !== "" &&
                                    <UncontrolledTooltip placement="right" target="evrakNo" delay={0}>
                                        {this.validateMessage("evrakNo")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className='row'>
                                <label className="col-sm-3">İlgili Yer: </label>
                                <div className={"col-sm-8 form-group" + this.validateClass('evrakIlgiliYer')}>
                                    <input className="form-control uppercase"
                                           disabled
                                           type="text"
                                           name="evrakIlgiliYer"
                                           id="evrakIlgiliYer"
                                           defaultValue={this.props.selectedDocument.evrakIlgiliYer || ""}
                                    />
                                    {this.validateMessage('evrakIlgiliYer') !== "" &&
                                    <UncontrolledTooltip placement="right" target="evrakIlgiliYer" delay={0}>
                                        {this.validateMessage("evrakIlgiliYer")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className='row'>
                                <label className="col-sm-3">Evrak Adı: </label>
                                <div className={"col-sm-8 form-group" + this.validateClass('evrakKonu')}>
                                    <input className="form-control uppercase"
                                           disabled
                                           type="text"
                                           name="evrakKonu"
                                           id="evrakKonu"
                                           defaultValue={this.props.selectedDocument.evrakKonu || ""}
                                    />
                                    {this.validateMessage('tUsername') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tUsername" delay={0}>
                                        {this.validateMessage("tUsername")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Evrak Türü:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('belgeTuru')}>
                                    <input className="form-control"
                                           disabled
                                           type="text"
                                           name="belgeTuru"
                                           id="belgeTuru"
                                           defaultValue={this.props.selectedDocument.belgeTuru || ""}
                                    />
                                    {this.validateMessage('belgeTuru') !== "" &&
                                    <UncontrolledTooltip placement="right" target="belgeTuru" delay={0}>
                                        {this.validateMessage("belgeTuru")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Geçerlilik Tarihi:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('sureBitisTarihi')}>
                                    <input {...sureBitisTarihi}
                                           className="basic-single form-control"
                                           disabled
                                           name="sureBitisTarihi"
                                           id="sureBitisTarihi"
                                           format="DD.MM.YYYY"
                                           ref="sureBitisTarihi"
                                           style={{width: "100%"}}
                                           value={(moment(this.props.selectedDocument.sureBitisTarihi).format( "DD.MM.YYYY")) || ""}
                                        // onChange={(date) => this.onChangeDocument("sureBitisTarihi", date)}
                                    />
                                    {this.validateMessage('sureBitisTarihi') !== "" &&
                                    <UncontrolledTooltip placement="right" target="sureBitisTarihi" delay={0}>
                                        {this.validateMessage("sureBitisTarihi")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div>
                                <div className="row">
                                    <Label className="col-sm-3">Dosya:</Label>
                                    <div className={"col-sm-8 form-group" + this.validateClass('evrakPath')}>
                                        {/*<a className="form-control"*/}
                                        {/*   id="evrakPath"*/}
                                        {/*   href={this.state.documentInfo.evrakPath || ""}*/}
                                        {/*   target="_blank"*/}
                                        {/*       // onChange={(e) => this.onChangeDocumentUpperCase("evrakPath")}*/}
                                        {/*>*/}
                                        {/*    {this.state.documentInfo.evrakKonu || ""}*/}
                                        {/*</a>*/}
                                        {this.validateMessage('evrakPath') !== "" &&
                                        <UncontrolledTooltip placement="right" target="evrakPath" delay={0}>
                                            {this.validateMessage("evrakPath")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            this.props.selectedDocument !== null && this.props.selectedDocument !== "null" && this.props.selectedDocument !== undefined ?
                                <div className="FormRenk col-sm-12">
                                    <span className="form-title">Açıklama</span>
                                    <div className="row">
                                        {/*<Label className="col-sm-3">{this.state.documentInfo.evrakNo} Evrak açıklaması: </Label>*/}
                                        <Label className="col-sm-3">Evrak açıklaması: </Label>
                                        <div
                                            className={"col-sm-8 form-group" + this.validateClass('aciklama')}>
                                            <h4 className="form-control" id="aciklama">
                                                {this.props.selectedDocument.evrakAciklama}
                                            </h4>
                                            {this.validateMessage('aciklama') !== "" &&
                                            <UncontrolledTooltip placement="right" target="aciklama"
                                                                 delay={0}>
                                                {this.validateMessage("aciklama")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                                :
                                ""
                        }
                        {this.props.selectedDocument.evrakSevkNots.length > 0 ?
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Not</span>
                            <div className="row">
                                <Label className="col-sm-3">Not: </Label>
                                <div
                                    className={"col-sm-8 form-group" + this.validateClass('evrakAciklama')}>
                                    {this.props.selectedDocument.evrakSevkNots.map((name) =>
                                        <h4 className="form-control" id="aciklama">
                                            {name.not}
                                        </h4>
                                    )}
                                    {this.validateMessage('evrakAciklama') !== "" &&
                                    <UncontrolledTooltip placement="right" target="evrakAciklama"
                                                         delay={0}>
                                        {this.validateMessage("evrakAciklama")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                            :
                            ""
                        }
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Not Ekleme</span>
                            <div className="row">
                                <Label className="col-sm-3">Not: </Label>
                                <div
                                    className={"col-sm-8 form-group" + this.validateClass('not')}>
                                    <input className="form-control uppercase"
                                           disabled={this.state.fieldsDisabled}
                                           type="textarea"
                                           name="not"
                                           id="not"
                                           maxLength="255"
                                           data-vlength="1,250"
                                           ref="not"
                                           onChange={(e) => this.onChangeDocumentLowerCase("not", e.target.value)}
                                    />
                                    {this.validateMessage('not') !== "" &&
                                    <UncontrolledTooltip placement="right" target="not"
                                                         delay={0}>
                                        {this.validateMessage("not")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>

                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Dosya Yükleme</span>
                            <div className="row">
                                <Label className="col-sm-3">Evrak Yükle: </Label>
                                <div className="col-sm-8 form-group">
                                    <UploaderDocument onInfoChange={this.onChangeDocument}
                                               fileName="evrakFile"
                                               thumbFileName="fotoThumbFile"
                                               filePathName="evrakPath"
                                               pathPrefix="foto"
                                               filePath={this.state.documentInfo.evrakPath}
                                               file={this.state.documentInfo.evrakFile}
                                               thumb={this.state.documentInfo.fotoThumbFile}
                                    />
                                    {/*<UploaderDocument onInfoChange={this.onChangeDocument}*/}
                                    {/*           fileName="file"*/}
                                    {/*           thumbFileName="fotoThumbFile"*/}
                                    {/*           filePathName="path"*/}
                                    {/*           pathPrefix="foto"*/}
                                    {/*           filePath={this.state.documentInfo.evrakPath}*/}
                                    {/*           file={this.state.documentInfo.evrakFile}*/}
                                    {/*           thumb={this.state.documentInfo.fotoThumbFile}*/}
                                    {/*/>*/}
                                </div>
                            </div>

                        </div>

                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Evrağın Sevk Edileceği Birim</span>
                            <div className="row">
                                <Label className="col-sm-3">Birim:</Label>
                                <div className="col-sm-8 form-group">
                                    <Select
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Birim Seçiniz."
                                        isClearable={false}
                                        isSearchable={false}
                                        name="selectedGroups"
                                        id="selectedGroups"
                                        ref="selectedGroups"
                                        isMulti
                                        style={{width: 250, height:"100%"}}
                                        inputProps={{'vdata': "required"}}
                                        options={this.props.branches && this.props.branches.map((branch)=>({
                                            label: branch.label,
                                            value: branch.value
                                        }))}
                                        onChange={(value) => this.onSelectInfoChange("selectedGroups", value)}
                                        // onChange={(value) => this.onChangeSelect("selectedGroups", value)}
                                        value={this.state.documentInfo.selectedGroups}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Kişi:</Label>
                                <div className="col-sm-8 form-group">
                                    <Select
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Birim Seçiniz."
                                        isClearable={false}
                                        isSearchable={false}
                                        name="selectedUsers"
                                        id="selectedUsers"
                                        ref="selectedUsers"
                                        isMulti
                                        style={{width: 250, height:"100%"}}
                                        inputProps={{'vdata': "required"}}
                                        options={this.props.roles && this.props.roles.map((rol)=>({
                                            label: rol.label,
                                            value: rol.value
                                        }))}
                                        onChange={(value) => this.onSelectInfoChange("selectedUsers", value)}
                                        value={this.state.documentInfo.selectedUsers}
                                    />
                                </div>
                            </div>
                        </div>
                    </Form>
                    <div className="save-button-container">
                        <button onClick={() => {
                            this.noteDocument()
                        }}
                                className="member-save-button"
                                disabled={this.state.isLoading}
                        >
                            KAYDET
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default DocumentNoteModal;



// WEBPACK FOOTER //
// ./src/page/documentList/DocumentNoteModal.js